import _ from "underscore"
import BasePDFDefinitionBuilder from "./BasePDFDefinitionBuilder";
import messageResource from "../messageResource"

export default class BaseReportPDFDefinitionBuilder extends BasePDFDefinitionBuilder {
    constructor() {
        super();
        this.columnStrategies = [];
        this.createRowMethodNames = ['makeFirstRow', 'makeSecondRow', 'makeThirdRow', 'makeFourthRow'];
    }

    init(paperOrientation, paperSize, columnStrategies, headerRowsNumber) {
        BasePDFDefinitionBuilder.prototype.init.call(this, paperOrientation, paperSize);
        this.columnStrategies = columnStrategies;
        this.headerRowsNumber = headerRowsNumber;

        var params = this.p("reportParams");
        if (!_.isUndefined(params)) {
            var width = [];
            for (var i = 0; i < this.columnStrategies.length; i++) {
                this.columnStrategies[i].setParams(params);
            }
        }

        return this;
    }

    getAdditionalStyles() {
        return styles;
    }

    getAdditionalTableLayouts() {
        return tableLayouts;
    }

    initDocDefinitionObject(withSignatureOnEachPage, headerOnEachPage) {
        BasePDFDefinitionBuilder.prototype.initDocDefinitionObject.call(this, headerOnEachPage);
        var margins = [];
        _.extend(margins, this.dd.pageMargins);

        this.dd.pageMargins = margins;

        var footerMargins = this.p("footerMargins")(this.p("pageMargins"));
        this.dd.footer = function() {
            return function(currentPage, pageCount) {
                return {
                    style: 'rightFooterPageCount',
                    margin: footerMargins,
                    layout: 'noBordersNoPadding',
                    text: messageResource.getMessage('report.chart_pdf.rightFooterLabel', [currentPage, pageCount])
                };
            }
        }();
    }

    iterateColumns(method, data) {
        var row = [];
        _.each(this.columnStrategies, function(strategy) {
            var rows = strategy[method](data);
            if (rows.length)
                _.each(rows, function(newRow) {row.push(newRow);});
            else
                row.push(rows);
        });

        return row;
    }

    createHeaderDataRow(headerData) {
        var header = {
            firstRow: this.iterateColumns('makeHeader', headerData)
        };

        if (this.headerRowsNumber > 1)
            header.secondRow = this.iterateColumns('makeSubHeader', headerData);

        if (this.headerRowsNumber > 2)
            header.thirdRow = this.iterateColumns('makeThirdLvlHeader', headerData);

        return header;
    }

    createTotalsRow(data) {
        return this.iterateColumns('makeTotals', data);
    }

    createRow(lvl, data) {
        return this.iterateColumns(this.createRowMethodNames[lvl], data);
    }

    addDataTable(headerRow, dataRows) {
        var tableMargins = {
            top: 20
        };
        var tableStyles = this.p("dataTableStyles");

        var rows = [];
        rows.push(headerRow.firstRow);

        if (headerRow.secondRow)
            rows.push(headerRow.secondRow);

        if (headerRow.thirdRow)
            rows.push(headerRow.thirdRow);

        var headerRowsNumber = rows.length;
        rows = rows.concat(dataRows);

        var sizes = this.p("columnWidth");

        var width = [];
        for (var i = 0; i < this.columnStrategies.length; i++) {
            this.columnStrategies[i].pushWidth(width, sizes);
        }

        var table = {
            style: tableStyles.tableStyle,
            layout: 'reportLayout',
            marginTop: tableMargins.top,

            table: {
                dontBreakRows: true,
                headerRows: headerRowsNumber,
                widths: width,
                body: rows
            }
        };
        this.appendContentElement(table);
    }
}

export const styles = {
    reportTable: {
        fontSize: 8
    },

    reportHeader: {
        fillColor: '#EFEFEF',
        color: '#373737',
        fontSize: 9,
        alignment: 'center',
        border: 1
    },

    reportSubHeader: {
        fillColor: '#F2F2F2',
        color: '#373737',
        fontSize: 9,
        alignment: 'center',
        border: 1
    },

    reportHeaderMargin: {
        margin: [2, 2, 0, 2]
    },

    reportTitleBigMargin: {
        margin: [0, 15, 2, 2]
    },

    reportTitleNormalMargin: {
        margin: [0, 10, 2, 2]
    },

    reportTitleSmallMargin: {
        margin: [0, 5, 2, 2]
    },

    reportRow: {
        fontSize: 9,
        alignment: 'center'
    },

    smallText: {
        fontSize: 8
    },

    tinyText: {
        fontSize: 7
    },

    negativeValue: {
        color: '#ed1c24'
    },

    grayText: {
        color: '#777777'
    },

    reportTotalValue: {
        bold: true,
        alignment: 'center'
    },

    reportFirstGroupingValue: {
        bold: true,
        alignment: 'center',
        fillColor: '#f4f4f4'
    },

    reportSecondGroupingValue: {
        bold: true,
        alignment: 'center',
        fillColor: '#f6f6f6'
    },

    reportThirdGroupingValue: {
        alignment: 'center'
    },

    reportFourthGroupingValue: {
        italics: true,
        alignment: 'center'
    },

    reportLevelsTitle: {
        alignment: 'left',
        margin: [6, 15, 2, 2]
    },

    reportTotalTitle: {
        margin: [0, 5, 2, 2]
    },

    reportTotal: {
        bold: true,
        marginRight: 3,
        alignment: 'right'
    },

    reportFirstGroupingRow: {
        bold: true,
        alignment: 'left',
        fillColor: '#f4f4f4'
    },

    reportFirstGroupingRowMargin: {
        marginLeft: 1
    },

    reportSecondGroupingRow: {
        bold: true,
        alignment: 'left',
        fillColor: '#f6f6f6'
    },

    reportSecondGroupingRowMargin: {
        marginLeft: 10
    },

    reportThirdGroupingRow: {
        alignment: 'left'
    },

    reportThirdGroupingRowMargin: {
        marginLeft: 20
    },

    reportFourthGroupingRow: {
        italics: true,
        alignment: 'left'
    },

    reportFourthGroupingRowMargin: {
        marginLeft: 30
    },

    rightFooterPageCount: {
        alignment: 'right',
        color: '#6A6A6A',
        fontSize: 7
    },

    asterisk: {
        color: '#f58f0a',
        fontSize: 6
    }
}

export const tableLayouts = {

    reportLayout: {
        hLineWidth() {
            return 1;
        },
        vLineWidth() {
            return 1;
        },
        hLineColor() {
            return '#cecece';
        },
        vLineColor() {
            return '#cecece';
        }
    }
};


// WEBPACK FOOTER //
// ./web/js/pdf/BaseReportPDFDefinitionBuilder.js